import '.d{display:flex;}.ssr-plugin'
import '.a2{align-items:stretch;}.ssr-plugin'
import '.ab{justify-content:center;}.ssr-plugin'
import '.e{flex-direction:column;}.ssr-plugin'
import '.dw{background:var(--palette-white);}.ssr-plugin'
import '.b3{flex-grow:1;}.ssr-plugin'
import '.r{align-items:center;}.ssr-plugin'
import '.aj{max-width:77.5rem;}.ssr-plugin'
import '.g7{justify-content:stretch;}.ssr-plugin'
import '.bk{position:sticky;}.ssr-plugin'
import '.bl{top:0px;}.ssr-plugin'
import '.bp{z-index:10;}.ssr-plugin'
import '.g8{padding-block:1rem;}.ssr-plugin'
import '.g9{height:3rem;}.ssr-plugin'
import '.ap{justify-content:space-between;}.ssr-plugin'
import '.as{flex-wrap:wrap;}.ssr-plugin'
import '.ga{margin-bottom:0px;}.ssr-plugin'
import '.gb{min-height:calc(100vh - 5rem);}.ssr-plugin'
import '.eq{margin-top:2rem;}.ssr-plugin'
import '.gc{padding-bottom:6rem;}.ssr-plugin'
import { ReactNode, useEffect } from 'react'
import { styled } from 'inlines'
import { Property } from 'csstype'
import useMediaQuery from '@app/util/useMediaQuery'
import { getTitleLevelStyle } from '@app/components/core/typography/styles'
import { CloseButton } from '@app/components/core/button/CloseButton'
import { pages } from '@app/util/links'
import { useLocation } from 'wouter'
import { ClientOnly, useAuthState } from '@based/sdk/react'
import { PageSeo } from '@app/components/core/seo/PageSeo'

export const PlotRegistryPageLayout = ({
  title,
  gap = '1rem',
  children,
  onClose,
}: {
  title: string
  gap?: Property.Gap<(string & {}) | 0>
  children: ReactNode
  onClose: VoidFunction
}) => {
  const isMobile = useMediaQuery()

  const authState = useAuthState()
  const [_location, navigate] = useLocation()
  const isAuthed = authState && authState.userId

  useEffect(() => {
    if (!isAuthed) {
      navigate(pages.home)
    }
  }, [isAuthed, navigate])

  return (
    <>
      <PageSeo pageTitle={title} noindex />
      <ClientOnly>
      <div className="d a2 ab e dw"
      >
        <div className="b3 d r ab e"
        >
          <div className="aj d e g7 bk bl bp dw"
            style={{
              width: isMobile ? '100%' : '85%',
              paddingInline: isMobile ? '5rem' : 0,}}
          >
            <nav className="g8 g9 d ap r as"
            >
              <styled.span className="ga"
                style={{
                  ...getTitleLevelStyle(5, isMobile),}}
              >
                {title}
              </styled.span>
              <CloseButton onClick={onClose} />
            </nav>
          </div>
          <div className="gb d e a2 eq gc aj"
            style={{
              gap: gap,
              width: isMobile ? '100%' : '85%',
              paddingInline: isMobile ? '5rem' : 0,}}
          >
            {children}
          </div>
        </div>
      </div>
      </ClientOnly>
    </>
  )
}
